import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  IDLE_STATUS,
  SUCCESS_STATUS,
  LOADING_STATUS,
  ALTERNATIVE_LOADING_STATUS,
  FAILURE_STATUS,
} from '../status';
import {
  fetchAll,
  fetchById,
} from './fundamentoLegalRegimeTributacaoIiAPI';
import i18n from '../../i18n';

const initialState = {
  status: IDLE_STATUS,
  error: null,
  response: {
    status: null,
    message: null,
    data: null,
  },
  list: [],
};

const fetchAllAsync = createAsyncThunk(
  'fundamentoLegalRegimeTributacaoIi/fetchAll',
  async (isDuimp) => {
    let queryParams = []
    if (isDuimp) {
      queryParams = [
        { name: 'isFundamentoDuimp', value: true },
      ]
    }
    const { data } = await fetchAll(queryParams);
    return { data };
  }
);

const fetchByIdAsync = createAsyncThunk(
  'fundamentoLegalRegimeTributacaoIi/fetchById',
  async (data) => {
    const response = await fetchById(data);
    return {
      response: {
        status: response.status,
        data: response.data,
      },
    };
  }
);

const fundamentoLegalRegimeTributacaoIiSlice = createSlice({
  name: 'fundamentoLegalRegimeTributacaoIi',
  initialState,
  reducers: {
    changeStatusTo: (state, action) => {
      state.status = action.payload.status;
    },
    loading: (state) => {
      state.status = LOADING_STATUS;
    },
    success: (state) => {
      state.status = SUCCESS_STATUS;
    },
    failure: (state) => {
      state.status = FAILURE_STATUS;
    },
    resetStatus: (state) => {
      state.status = IDLE_STATUS;
    },
    setResponse: (state, action) => {
      state.response = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearResponse: (state) => {
      state.response = {
        status: null,
        message: null,
        data: null,
      };
    },
    resetList: (state) => {
      state.list = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllAsync.pending, (state) => {
        state.status = ALTERNATIVE_LOADING_STATUS;
      })
      .addCase(fetchAllAsync.fulfilled, (state, action) => {
        state.status = IDLE_STATUS;
        state.list = action.payload.data;
      })
      .addCase(fetchAllAsync.rejected, (state, action) => {
        state.status = FAILURE_STATUS;
        state.error = {
          ...action.error,
          message: i18n.t('com.muralis.qcx.erro.erroCarregarListaFundamentosLegaisRegimeTributacaoII', { erro: action.error.message }),
        };
      })
      .addCase(fetchByIdAsync.pending, (state) => {
        state.status = LOADING_STATUS;
      })
      .addCase(fetchByIdAsync.fulfilled, (state, action) => {
        if (action.payload.response.status === 200) {
          state.model = action.payload.response.data;
          state.status = SUCCESS_STATUS;
        }
      })
      .addCase(fetchByIdAsync.rejected, (state, action) => {
        state.status = FAILURE_STATUS;
        state.error = {
          ...action.error,
          message: i18n.t('com.muralis.qcx.erro.erroCarregarDadosFundamentoLegalRegimeTributacaoII', { erro: action.error.message }),
        };
      });
  },
});

const {
  changeStatusTo,
  loading,
  success,
  failure,
  resetStatus,
  setResponse,
  setResponseMessage,
  clearResponse,
  setError,
  resetList,
} = fundamentoLegalRegimeTributacaoIiSlice.actions;

const selectFundamentosLegaisRegimeTributacaoIi = (state) => (
  state.fundamentoLegalRegimeTributacaoIi.list
);
const selectStatus = (state) => state.fundamentoLegalRegimeTributacaoIi.status;
const selectError = (state) => state.fundamentoLegalRegimeTributacaoIi.error;
const selectResponse = (state) => state.fundamentoLegalRegimeTributacaoIi.response;

export {
  fundamentoLegalRegimeTributacaoIiSlice,
  changeStatusTo,
  loading,
  success,
  failure,
  resetStatus,
  setResponse,
  setResponseMessage,
  clearResponse,
  setError,
  fetchAllAsync,
  fetchByIdAsync,
  resetList,
  selectFundamentosLegaisRegimeTributacaoIi,
  selectStatus,
  selectError,
  selectResponse,
};

export default fundamentoLegalRegimeTributacaoIiSlice.reducer;
